import { useEffect, useState } from "react";

/** Animated integer counter — respects prefers-reduced-motion. */
export default function CountUp({ value = 0, decimals = 0, duration = 900, prefix = "", suffix = "" }) {
  const [display, setDisplay] = useState(value);
  useEffect(() => {
    const reduced = typeof window !== "undefined"
      && window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (reduced) { setDisplay(value); return; }
    const start = performance.now();
    const from = display || 0;
    const to = Number(value) || 0;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (to - from) * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration]);
  const num = Number(display).toLocaleString(undefined, {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
  return <span className="tabular-nums">{prefix}{num}{suffix}</span>;
}
